import {createSelector} from 'reselect'
import {getSingleCPSelection} from '../common/selectors'
import {getCustomers, getProjects} from '../../entities/selectors'
import messageResource from '../../messageResource'

export const getHeaderTitle = createSelector(
    getSingleCPSelection,
    getCustomers,
    getProjects,
    (cpSelection, customers, projects) => {
        return !!cpSelection.projectId ? projects[cpSelection.projectId].name
                                       : !!cpSelection.customerId ? customers[cpSelection.customerId].name
                                                                  : messageResource.getMessage("task.list.all_customers")
    }
)

export const isShowArchivedLabel = createSelector(
    getSingleCPSelection,
    getCustomers,
    getProjects,
    (cpSelection, customers, projects) => {
        return !!cpSelection.projectId ? projects[cpSelection.projectId].archived
                                       : !!cpSelection.customerId ? customers[cpSelection.customerId].archived
                                                                  : false
    }
)


// WEBPACK FOOTER //
// ./web/js/taskManagement/header/selectors.js